import { fetchClients, fetchAllClients, fetchClientInfo, fetchClientExporation } from './services';
import { setClients, setAllClients, handleLoading } from './actions';
import { handleExporting } from '../../../components/Filter/store/actions';

export const requestLoadClients = ({
  userId,
  establishmentId,
  page,
  qp = ''
}) => dispatch => {
  let url = `${userId}/clients?page=${page}&orderBy=name&sort=asc${qp}`;

  if(establishmentId) {
    url = `${userId}/establishment/${establishmentId}/clients?page=${page}&orderBy=name&sort=asc${qp}`;
  }

  dispatch(handleLoading(true));

  return fetchClients(url)
    .then(({ data }) => {
      dispatch(setClients(data.content, data.total));
      dispatch(handleLoading(false));
    })
    .catch(err => console.log('err', err))
    .finally(() => dispatch(handleLoading(false)));
}

export const loadAllClients = (userId, establishmentId, name) => dispatch => {
  return fetchAllClients(userId, establishmentId, name).then(data => {
    dispatch(setAllClients(data?.data || []));
  });
}

export const loadClientInfo = (userId, establishmentId, clientId) => dispatch => {
  return fetchClientInfo(userId, establishmentId, clientId)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject();
    });
}

export const requestClientExportation = (userId, establishmentId, qp, isCsv = false) => dispatch => {
  dispatch(handleExporting(true));

  let url = `${userId}/clients/export?orderBy=name&sort=asc${qp}`;

  if(establishmentId) {
    url = `${userId}/establishment/${establishmentId}/clients/export?orderBy=name&sort=asc${qp}`;
  }

  return fetchClientExporation(url)
    .then(({ data }) => {
      dispatch(handleExporting(false));

      if(isCsv) {
        return data;
      }

      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject({});
    });
}